import React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
} from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

const PublicNavbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, successMessage, loading } = useAppSelector((state) => state.auth);
  
  // Check if we're on login or register page and showing success message
  const isOnAuthPage = location.pathname === '/login' || location.pathname === '/register';
  const showingSuccessMessage = successMessage && isOnAuthPage;
  
  // Don't change button text if we're showing success message on auth pages or if auth state is still loading
  const shouldShowDashboardButton = isAuthenticated && !showingSuccessMessage && !loading;

  return (
    <>
      {/* Logo positioned absolutely outside navbar */}
      <Box 
        onClick={() => navigate('/')}
        sx={{ 
          position: 'fixed',
          top: '-16px',
          left: '24px',
          backgroundColor: '#a31830',
          borderRadius: 0,
          px: 2,
          py: 2.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '96px',
          zIndex: 1002,
          cursor: 'pointer'
        }}
      >
        <img
           src="/assets/agrana-logo.svg"
           alt="AGRANA Logo"
           style={{
             height: '48px',
             width: 'auto',
             filter: 'brightness(0) invert(1)', // Make white SVG visible
           }}
        />
      </Box>
      
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: 'white',
          borderBottom: '1px solid #e0e0e0',
          boxShadow: 'none',
          zIndex: 1000,
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', px: 3, minHeight: '64px !important', height: '64px', paddingLeft: '140px' }}>
           <Box sx={{ flexGrow: 1 }} />

          {/* Right side - Plain text with arrow */}
           {/* Only render the button when we're sure about authentication state */}
          {!loading && (
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.7,
                },
                transition: 'opacity 0.2s ease',
              }}
              onClick={() => {
                if (shouldShowDashboardButton) {
                  navigate('/dashboard');
                  return;
                }
                // On landing page, keep user on the same page and reveal login
                if (location.pathname === '/') {
                  navigate('/#login');
                  return;
                }
                navigate('/login');
              }}
            >
              <Typography
                sx={{
                  color: '#333',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                }}
              >
                {shouldShowDashboardButton ? 'Go to Dashboard' : 'Login'}
              </Typography>
              <ArrowForward 
                sx={{ 
                  color: '#333', 
                  fontSize: '1rem' 
                }} 
              />
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default PublicNavbar;